module.exports = __webpack_public_path__ + "static/img/SI.3e5dc375.jpg";